import React from 'react';
import { useAudio } from '../../../../../../contexts';
import { Box } from '../../../../../Box';
import { Flex } from '../../../../../Flex';
import { Typography } from '../../../../../Typography';
import { colorsMapper } from '../../../../AudioPlayer.utils';
import * as S from './styled';
var speedOptions = [0.75, 1, 1.25, 1.5, 2];
export var SpeedConfiguration = function SpeedConfiguration(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'green' : _ref$color,
      title = _ref.title;

  var _useAudio = useAudio(),
      setSpeed = _useAudio.setSpeed,
      speed = _useAudio.speed;

  var getHandleOnClick = function getHandleOnClick(s) {
    return function () {
      return setSpeed(s);
    };
  };

  return /*#__PURE__*/React.createElement(Box, {
    padding: '15px 24px 15px 24px'
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subheading2",
    marginBottom: "20px",
    userSelect: "none"
  }, title), /*#__PURE__*/React.createElement(Flex, {
    width: "317px",
    justifyContent: "space-between",
    paddingRight: "20px"
  }, speedOptions.map(function (s) {
    return /*#__PURE__*/React.createElement(S.Button, {
      key: s,
      active: speed === s,
      onClick: getHandleOnClick(s),
      background: colorsMapper[color]
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: speed === s ? 'subheading' : 'subheading2'
    }, s + 'x'));
  })));
};